export const PROVIDERS = [
  { value: "7", label: "Brittany Hodkinson" },
  { value: "9", label: "Therese Searle" },
  { value: "11", label: "Lori Aasen" },
  { value: "12", label: "Jill Hansen" },
  { value: "13", label: "Katherine Trelstad" },
  { value: "14", label: "Phillip Stiles" },
  { value: "16", label: "Kristina Bechtel" },
  { value: "20", label: "Aruna Evenson" },
  { value: "21", label: "Grace Modina" },
  { value: "24", label: "Mary Jirak" },
];
